export var pcCssPrefix = 'cn-ui-ding-talk-scan';
export var mCssPrefix = 'cn-ui-m-ding-talk-scan';
